// @ts-nocheck
/** Format an ISO timestamp like `Mar 14, 3:45 PM`; `—` when missing. */
export const fmtDate = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

/** Format a duration in seconds as `Xm Ys` (or `Ns` under a minute); `—` when missing/zero. */
export const fmtDuration = (s) => {
  if (!s) return '—';
  const m = Math.floor(s / 60);
  return m === 0 ? `${s}s` : `${m}m ${s % 60}s`;
};

/** Format a 0..1 fraction as a one-decimal percentage, e.g. `0.7531 → "75.3%"`. */
export const pctFmt = (v) => `${(v * 100).toFixed(1)}%`;
